import { SxProps, Theme } from '@mui/material'

type Styles = Record<string, SxProps<Theme>>

export type PillTone = 'INFO' | 'WARNING' | 'NEUTRAL' | 'DOWNGRADE'

const PILL_BASE_SX = {
  fontSize: '11px',
  fontWeight: 600,
  px: '8px',
  py: '2px',
  borderRadius: '100px',
  ml: 1,
}

const PILL_TONE_COLORS: Record<PillTone, { backgroundColor: string; color: string }> = {
  INFO: { backgroundColor: 'primary.lightest', color: 'primary.main' },
  WARNING: { backgroundColor: 'warning.lightest', color: 'warning.dark' },
  NEUTRAL: { backgroundColor: 'grey.100', color: 'text.secondary' },
  DOWNGRADE: { backgroundColor: 'error.lightest', color: 'error.dark' },
}

export const getPillSx = (tone: PillTone): SxProps<Theme> => ({
  ...PILL_BASE_SX,
  ...PILL_TONE_COLORS[tone],
})

export const getPriceDeltaSpanSx = (isPositive: boolean): SxProps<Theme> => ({
  color: isPositive ? 'success.dark' : 'error.main',
  fontWeight: 600,
})

export const changePlanDialogStyles: Styles = {
  dialogContent: {
    p: 3,
  },
  stepContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
  },
  alert: {
    fontSize: '13px',
  },
  swapIcon: {
    fontSize: 16,
    color: 'text.secondary',
  },
  confirmRowContainer: {
    border: '1px solid',
    borderColor: 'divider',
    borderRadius: '8px',
    overflow: 'hidden',
  },
  confirmRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    p: 2,
  },
  changingToValue: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
  },
  agreementItem: {
    border: '1px solid',
    borderColor: 'divider',
    borderRadius: 2,
    p: 2,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  agreementSignedBadge: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
  },
}

export const getPlanOptionCardSx = (isSelected: boolean): SxProps<Theme> => ({
  border: '1px solid',
  borderColor: isSelected ? 'primary.main' : 'divider',
  borderRadius: '8px',
  p: 2,
  cursor: 'pointer',
  backgroundColor: isSelected ? 'primary.lightest' : 'transparent',
  '&:hover': { borderColor: 'primary.main' },
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
})
